import { useCardCollectionStore } from '~/stores/card-collection';
import { useCardStore } from '~/stores/card';
import { useFileTreeStore } from '~/stores/file-tree';
import { useModalStore } from '~/stores/modalStore';
import { useNotificationStore } from '~/stores/notificationStore';
import { useUserStore } from '~/stores/user';
import { useSideMenuStore } from '~/stores/side-menu-control';

export async function resetAllStores() {
  const cardCollectionStore = useCardCollectionStore();
  const cardStore = useCardStore();
  const fileTreeStore = useFileTreeStore();
  const modalStore = useModalStore();
  const notificationStore = useNotificationStore();
  const userStore = useUserStore();
  const sideMenuStore = useSideMenuStore();

  // Reset all stores to their initial state
  cardCollectionStore.$reset();
  cardStore.$reset();
  await fileTreeStore.reset();
  modalStore.$reset();
  notificationStore.$reset();
  userStore.$reset();
  sideMenuStore.$reset();

  // Optionally, you can also clear localStorage or sessionStorage if needed
}
